<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  title:        { type: String,  default: "Are you sure?" },
  message:      { type: String,  default: "This action cannot be undone." },
  confirmLabel: { type: String,  default: "Delete" },
  loading:      { type: Boolean, default: false },
});
const emit = defineEmits(["update:modelValue", "confirm"]);
</script>

<template>
  <VDialog :model-value="modelValue" max-width="420" @update:model-value="emit('update:modelValue', $event)">
    <VCard>
      <VCardTitle class="text-h6 pt-5 px-6">{{ title }}</VCardTitle>
      <VCardText class="px-6">{{ message }}</VCardText>
      <VCardActions class="px-6 pb-5 justify-end gap-2">
        <VBtn variant="tonal" :disabled="loading" @click="emit('update:modelValue', false)">Cancel</VBtn>
        <VBtn color="error" :loading="loading" @click="emit('confirm')">{{ confirmLabel }}</VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
